import React from "react";
import { FooterBrand } from "./footer/FooterBrand";
import { FooterContact } from "./footer/FooterContact";
import { FooterLinkColumn } from "./footer/FooterLinkColumn";
import {
  FooterDisclaimer,
  FooterPartners,
  FooterTrustBadges,
  FooterCopyright,
} from "./footer/FooterMeta";
import {
  CATEGORY_LINKS,
  BUSINESS_LINKS,
  SHOP_LINKS,
  COMPANY_LINKS,
} from "./footer/footerLinks";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#fffaf5] border-t border-[#f0d8d4]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 md:gap-10">
          <FooterBrand />
          <FooterLinkColumn title="Categories" links={CATEGORY_LINKS} testid="footer-categories" />
          <FooterLinkColumn title="For Business" links={BUSINESS_LINKS} testid="footer-business" />
          <FooterLinkColumn title="Shop" links={SHOP_LINKS} />
          <FooterLinkColumn title="Company" links={COMPANY_LINKS} />
          <FooterContact />
        </div>

        <FooterDisclaimer />
        <FooterPartners />
        <FooterTrustBadges />
        <FooterCopyright year={currentYear} />
      </div>
    </footer>
  );
};

export default Footer;
